<template>
  <div id="about_sailuk">
    <u-animate-container>
      <div class="left">
        <img src="@/assets/images/bg_index_about_left.png" class="logo" />
        <img src="@/assets/images/logo_about_xihe.png" class="xihe" />
      </div>
      <div class="right">
        <u-animate
          class="info"
          name="fadeInRight"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <div class="title_en"></div>
          <div class="title_cn">{{ $t("index.aboutXiHe") }}</div>
          <p class="desc">{{ $t("index.aboutDesc") }}</p>
          <p class="desc">{{ $t("index.aboutName") }}</p>
          <div class="btn_about" @click="goAbout">
            {{ $t("index.aboutXiHe") }}
          </div>
        </u-animate>
        <img src="@/assets/images/bg_index_about_right.png" />
      </div>
    </u-animate-container>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  data() {
    return {};
  },
  props: {
    locale: {
      type: String,
      default: "cn"
    }
  },
  created() {},
  methods: {
    goAbout() {
      this.$router.push({
        path: "/about"
      });
    }
  }
};
</script>

<style scoped lang="scss">
#about_sailuk {
  width: 100%;
  height: 300px;
  position: relative;
  .left {
    position: absolute;
    width: 52%;
    background: #fd8204;
    height: 280px;
    top: 0;
    left: 0;
    z-index: 2;
    img.logo {
      width: 180px;
      height: auto;
      float: left;
      position: absolute;
      top: 45px;
      right: 50%;
    }
    img.xihe {
      width: 230px;
      height: auto;
      position: absolute;
      top: 60px;
      right: 25%;
    }
  }
  .right {
    position: absolute;
    left: 49%;
    top: 30px;
    width: 52%;
    background: #f2f2f2;
    height: 280px;
    z-index: 1;
    img {
      height: 100%;
      width: auto;
      position: absolute;
      left: 15%;
      top: 0;
      z-index: 1;
    }
    .info {
      position: absolute;
      z-index: 2;
      left: 12%;
      .title_en {
        color: #fd8204;
        font-size: 0.15rem;
        width: 100%;
        margin-top: 45px;
        margin-bottom: 10px;
      }
      .title_cn {
        font-size: 0.34rem;
        color: #000;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .desc {
        color: #333333;
        font-size: 0.18rem;
        margin-bottom: 10px;
        &:last-of-type {
          margin-bottom: 25px;
        }
      }
      .btn_about {
        color: #fd8204;
        font-size: 16px;
        border: 2px solid #fd8204;
        border-radius: 25px;
        width: 130px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-weight: bold;
        transition: all 0.35s;
        &:hover {
          cursor: pointer;
          background: #fd8204;
          color: #fff;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #about_sailuk {
    height: auto;
    .left {
      display: none;
    }
    .right {
      float: right;
      width: 100%;
      height: auto;
      top: auto;
      position: relative;
      left: auto;
      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 60px;
        width: 100%;
        left: 0;
        position: relative;
        .title_en {
          margin-top: 0;
          font-size: 0.6rem;
          text-align: center;
        }
        .title_cn {
          font-size: 1.5rem;
        }
        .desc {
          font-size: 0.8rem;
        }
        .btn_about {
          width: 5.5rem;
          height: 1.8rem;
          font-size: 0.7rem;
          line-height: 1.8rem;
        }
      }
      img {
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: auto;
        top: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Index/IndexAbout.vue